// extracted by mini-css-extract-plugin
module.exports = {"w1ay2007":"w1ay2007","point-w1ay2007":"point-w1ay2007","tdthhle":"tdthhle"};